// import constants from './constants';

export default {
};



// WEBPACK FOOTER //
// ./src/store/modules/emailHistory/getters.js